// src/pages/ielts/reading/ReadingHasilPage.jsx
import { useLocation } from 'react-router-dom';
import ResultModal from '../../../components/Ielts_test/hasil/reading/ResultModal';

export default function ReadingHasilPage() {
  const { state } = useLocation();
  const result = state?.result;

  if (!result) {
    return <div className="p-8 text-center">Tidak ada hasil.</div>;
  }

  return <ResultModal result={result} onClose={() => window.history.back()} />;
}